import PageShell from "@/components/layout/PageShell";
import ContactCTA from "@/components/sections/ContactCTA";
import FAQ from "@/components/sections/FAQ";

export default function ContactPage() {
  return (
    <PageShell
      testId="contact-page"
      eyebrow="Contact APEX Innovation Solutions"
      title={<>Let's build something that <span className="text-apex-orange">actually grows your business.</span></>}
      subtitle="Send us a note about your project. Our team replies within one business day with next steps and a proposal for a free strategy call. All queries go to info@apexinnovationsolutions.com."
      breadcrumbs={[{ label: "Contact" }]}
      seoTitle="Contact APEX Innovation Solutions | Web Design & SEO Enquiry"
      seoDescription="Contact APEX Innovation Solutions — web design, SEO, and AEO agency. Email info@apexinnovationsolutions.com, call +91 77197 79448, or use the form."
    >
      <ContactCTA />
      <FAQ />
    </PageShell>
  );
}
